import reg from '@/js/regular'
import util from '@/js/util'
import {debounce} from '@/js/debounce.js'
const tmsMixin = {
  methods: {
    // 检查页面是否被修改
    checkModuleListAdd(item) {
      let flag = true;
      if (this.pageData && this.pageData.module_list) {
        this.pageData.module_list.map((val) => {
          if (val.module_code === 'back_top' && item.module_code === 'back_top') {
            this.$message.error('一个页面只能有一个返回顶部');
            flag = false;
          }
          if (val.module_code === 'rule' && item.module_code === 'rule') {
            this.$message.error('一个页面只能有一个规则');
            flag = false;
          }
          if (val.module_code === 'countdown' && item.module_code === 'countdown') {
            this.$message.error('一个页面只能有一个倒计时');
            flag = false;
          }
          if (val.module_code === 'bottom_nav' && item.module_code === 'bottom_nav') {
            this.$message.error('一个页面只能有一个底部导航');
            flag = false;
          }
          if (val.module_code === 'top_nav' && item.module_code === 'top_nav') {
            this.$message.error('一个页面只能有一个顶部导航');
            flag = false;
          }
          if (val.module_code === 'form' && item.module_code === 'form') {
            this.$message.error('一个页面只能有一个表单');
            flag = false;
          }
          if (val.module_code === 'bottom_float' && item.module_code === 'bottom_float') {
            this.$message.error('一个页面只能有一个底部悬浮');
            flag = false;
          }
        })
      }
      return flag;
    }
  }
}

const orderListMixin = {
  data() {
    return {
      queryLoading: false
    }
  },
  methods: {
    // 获取优惠信息
    getDiscountInfo(order) {
      let txt = '', discount_amount = '';
      if (order.discount_amount) {
        discount_amount = order.discount_amount / 100;
        if (order.discount_list) {
          order.discount_list.map((val, index) => {
            txt += index === 1 ? '，' : '';
            txt += val.discount_type === 1 ? '会员' : '红包';
            txt += '￥' + (val.discount_amount / 100);
          });
          txt = `￥${discount_amount} (${txt})`;
        } else {
          txt += '￥0';
        }
      } else {
        txt += '￥0';
      }
      return txt;
    },
    formatStatus(status, type = 'goods') {
      switch (status) {
        case 10:
          return '待支付';
        case 20:
          return '买家已取消';
        case 21:
          return '卖家已取消';
        case 30:
          if(type === 'goods') {
            return '待发货';
          }
          return '待使用';
        case 40:
          if(type === 'goods') {
            return '已发货'
          }
          return '已使用';
        case 50:
          return '已签收';
        case 60:
          return '已评价';
        case 70:
          return '退款中';
        case 80:
          return '退款完成';
        case 90:
          return '已完成';
        default:
          return '--'
          break;
      }
    },
    // 格式化类型
    formatOrderType(type) {
      switch (type) {
        case 10:
        case 11:
          return '【拼】'
        case 14:
        case 15:
          return '【砍】'
        default:
          return ''
          break;
      }
    },
    // 格式化金额
    formatCurrentPrice(price) {
      return '¥'+util.filterPrice(price)
    }
  }
}

// 有表格时的页面
const pageMixin = {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      totalCount: 0,
      queryLoading: false,    //表格加载LOADING

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      tableData: []     //表格数据
    }
  },
  created() { //加载是 混入query
    let _query_ = this.$route.query
    for(let key in _query_) {
      if(_query_[key]) {
        this.searchForm[key] = _query_[key]
      }
    }
  },
  methods: {
    checkIsInt (rule, value, callback) {  //表格的表单验证--验证整数 有值时才验证
      if (!value) {
        return callback();
        // return
      }
      if (!reg.isInt(value)) {
        callback(new Error('请输入整数'));
      } else {
        callback()
      }
    },

    search: debounce(function(type) {     //按钮搜索
      if(type === 'verify') { // 如果是需要验证表单
        this.$refs.searchForm.validate((valid) => {
          if(valid) {
            console.log('验证通过。。。')
            this.pageNum = 1
            this.getTableData()
          } else {
            console.log('表单验证不通过')
            return false
          }
        })
      } else {
        this.pageNum = 1
        this.getTableData()
      }
    }, 300),
    handleCurrentChange(val) {    //  页面改变
      this.pageNum = val
      this.paginationEvent()
    },
    handleSizeChange(val) {     //  页数改变
      this.pageSize = val
      this.pageNum = 1
      this.paginationEvent()
    },
    paginationEvent() {         //页码 页数改变时 触发分页事件
      console.log(this.pageNum, this.pageSize)
      this.getTableData()
    },

    formatPrice(price) {    //格式化金钱
      return '¥'+util.filterPrice(price)
    },
  }
}

export {
  orderListMixin,
  tmsMixin,

  pageMixin
}
